import { TIconComponent } from "@/types/app"
import { cn } from "@/lib/utils"

const CaNextBankLogo = ({
  className,
  width,
  ...restProps
}: Omit<TIconComponent, "height">) => {
  return (
    <svg
      width={width}
      preserveAspectRatio="xMinYMin meet"
      viewBox="0 0 226.6 131.5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("heading__logo", className)}
      {...restProps}
    >
      <g>
        <path
          className="st0"
          d="M1.9,1h7.2l0.1,21.9C14.9,5.9,23.1,0.5,29,0.5c6.1,0,10.4,3.2,12,15.2h0.6c9.2,0,12.8,4.6,12.8,19.2v16.6h-7.2
		V34.8c0-10.7-1.7-12.7-5.6-12.7c0.1,2,0.1,4.2,0.1,6.7c0,11.4-3.7,15.6-9.8,15.6c-5.8,0-9.4-3.7-9.4-11.1c0-9,5-14.4,11.6-16.6
		c-0.7-8.8-2.5-9.9-5.5-9.9c-4.5,0-15.6,8.2-19.3,44.5H2.2C2.2,49.1,1.9,7.9,1.9,1L1.9,1z M31.9,38c1.7,0,2.6-1.2,2.6-9.2l-0.1-5.3
		c-3,1.7-4.7,4.7-4.7,9.8C29.8,36.8,30.5,38,31.9,38L31.9,38z"
        />
        <path
          d="M80.3,23.8h6.4v27.6h-6.2l-0.3-4c-1.5,3.2-5.7,4.8-8.7,4.9c-7.9,0.1-13.8-5-13.8-14.7s6.1-14.5,14-14.5
		c3.6,0,7,1.7,8.5,4.5C80.1,27.7,80.3,23.8,80.3,23.8z M64.2,37.6c0,5.3,3.5,8.4,7.9,8.4c10.4,0,10.4-16.7,0-16.7
		C67.8,29.3,64.2,32.4,64.2,37.6z"
        />
        <path d="M130.7,23.8l-11.4,27.8h-7.2l-11.5-27.8h7.2l3.7,9.1l4.1,11.6l4.1-11.5l3.7-9.2L130.7,23.8L130.7,23.8z" />
        <path d="M140.9,16.1c0,5.3-7.8,5.3-7.8,0S140.9,10.7,140.9,16.1z M133.7,23.7v27.7h6.6V23.7H133.7z" />
        <path
          d="M151.8,40.1c0.4,3.4,3.3,5.9,8,5.9c2.4,0,5.6-1,7.2-2.6l4.2,4.3c-2.8,3-7.4,4.5-11.5,4.5c-9.2,0-14.7-5.9-14.7-14.7
		S150.5,23,159.2,23s14.6,5.7,13.5,17.1L151.8,40.1L151.8,40.1z M166.4,34.4c-0.4-3.6-3.1-5.4-6.9-5.4c-3.6,0-6.5,1.8-7.5,5.4H166.4
		z"
        />
        <path
          d="M6.8,90.1c0.4,3.4,3.3,5.9,8,5.9c2.4,0,5.6-0.9,7.2-2.6l4.2,4.3c-2.8,3-7.4,4.5-11.5,4.5C5.5,102.2,0,96.3,0,87.4
		S5.5,73,14.2,73s14.6,5.7,13.5,17.1L6.8,90.1L6.8,90.1z M21.4,84.4c-0.4-3.6-3.2-5.4-7-5.4c-3.6,0-6.5,1.8-7.5,5.4H21.4z"
        />
        <path
          d="M52.4,101.4V87c0-4.2-2.2-7.4-6.5-7.4s-6.8,3.5-6.8,7.7v14.1h-6.6V73.8h5.9l0.4,3.8c2.7-2.7,5.4-4.1,8.8-4.1
		C54,73.4,59,78.3,59,86.9v14.5C59,101.4,52.4,101.4,52.4,101.4z"
        />
        <path
          d="M92.9,81.2c-1.9-1.8-4.1-2.5-6.6-2.5c-3.2,0-4.9,1-4.9,2.7s1.6,2.8,5,3c5.1,0.3,11.5,1.5,11.5,8.8c0,4.9-3.9,9.1-11.5,9.1
		c-4.2,0-8.5-0.7-12.4-4.9l3.3-4.9c1.9,2.2,6.2,3.8,9.2,3.9c2.5,0.1,4.8-1.3,4.8-3.3c0-1.9-1.5-2.7-5.3-2.9
		c-5.1-0.4-11.1-2.3-11.1-8.6s6.4-8.6,11.3-8.6c4.2,0,7.3,0.8,10.4,3.6L92.9,81.2L92.9,81.2z"
        />
        <path
          d="M108.7,73.8v14.4c0,4.2,2.2,7.4,6.5,7.4s6.8-3.5,6.8-7.7V73.8h6.6v27.7h-5.9l-0.4-3.8c-2.8,2.8-5.3,4.1-9.1,4.1
		c-6.4,0-11.1-5-11.1-13.6V73.8L108.7,73.8L108.7,73.8z"
        />
        <path d="M141.5,66.1c0,5.3-7.8,5.3-7.8,0S141.5,60.7,141.5,66.1z M134.3,73.7v27.7h6.6V73.7H134.3z" />
        <path
          d="M164.2,81.2c-1.9-1.8-4.1-2.5-6.6-2.5c-3.1,0-4.9,1-4.9,2.7s1.6,2.8,5,3c5.1,0.3,11.5,1.5,11.5,8.8c0,4.9-3.9,9.1-11.5,9.1
		c-4.2,0-8.5-0.7-12.4-4.9l3.3-4.9c1.9,2.2,6.2,3.8,9.2,3.9c2.5,0.1,4.8-1.3,4.8-3.3c0-1.9-1.5-2.7-5.3-2.9
		c-5.1-0.4-11.1-2.3-11.1-8.6s6.4-8.6,11.3-8.6c4.2,0,7.3,0.8,10.4,3.6L164.2,81.2L164.2,81.2z"
        />
        <path
          d="M190.7,81.2c-1.9-1.8-4.1-2.5-6.6-2.5c-3.1,0-4.9,1-4.9,2.7s1.6,2.8,5,3c5.1,0.3,11.5,1.5,11.5,8.8c0,4.9-3.9,9.1-11.5,9.1
		c-4.2,0-8.5-0.7-12.4-4.9l3.3-4.9c1.9,2.2,6.2,3.8,9.2,3.9c2.5,0.1,4.8-1.3,4.8-3.3c0-1.9-1.5-2.7-5.3-2.9
		c-5.1-0.4-11.1-2.3-11.1-8.6s6.4-8.6,11.3-8.6c4.2,0,7.3,0.8,10.4,3.6L190.7,81.2L190.7,81.2z"
        />
        <path
          d="M205.4,90.1c0.4,3.4,3.3,5.9,8,5.9c2.4,0,5.6-0.9,7.2-2.6l4.2,4.3c-2.8,3-7.4,4.5-11.5,4.5c-9.2,0-14.7-5.9-14.7-14.7
		S204.1,73,212.8,73s14.6,5.7,13.5,17.1L205.4,90.1L205.4,90.1z M219.9,84.4c-0.4-3.6-3.1-5.4-6.9-5.4c-3.6,0-6.5,1.8-7.5,5.4H219.9
		z"
        />
      </g>
      <g>
        <path
          d="M1.3,111.8v6c0.7-1.5,2.2-2.2,3.8-2.2c2.5,0,4.6,1.8,4.6,4.8s-2,4.8-4.6,4.8c-1.6,0-3-0.8-3.8-2.2v2.1H0.5v-13.3L1.3,111.8
		L1.3,111.8z M1.4,120.3c0,2.3,1.6,3.9,3.7,3.9s3.7-1.3,3.7-3.9s-1.7-3.9-3.7-3.9S1.4,118,1.4,120.3z"
        />
        <path d="M18.8,115.7L13.2,129h-1l1.7-4l-3.6-9.3h1l2.1,5.6l1.1,2.7l1-2.7l2.3-5.5L18.8,115.7L18.8,115.7z" />
        <path
          d="M35.4,123.2c-1.3,1.3-3,2-4.7,2c-4.3,0-6.6-3.1-6.6-6.7c0-3.6,2.2-6.9,6.6-6.9c1.7,0,3.4,0.7,4.7,2l-0.7,0.6
		c-1.1-1.1-2.6-1.7-4-1.7c-3.8,0-5.7,2.7-5.7,5.9c0,3.1,2,5.8,5.7,5.8c1.5,0,2.9-0.6,4-1.7L35.4,123.2z"
        />
        <path
          d="M37.3,115.7l0,1.7c0.6-1.3,1.9-1.8,3-1.8c0.7,0,1.3,0.2,2,0.6l-0.4,0.8c-0.5-0.3-1-0.4-1.5-0.4c-1.7,0-3,1.4-3,3.1v5.5
		h-0.9v-9.4L37.3,115.7L37.3,115.7z"
        />
        <path
          d="M47.3,125.2c-2.6,0-4.6-1.8-4.6-4.8c0-2.8,2.1-4.8,4.6-4.8s4.8,1.6,4.5,5.3h-8.2c0.2,2.2,1.8,3.5,3.7,3.5
		c1.2,0,2.6-0.5,3.3-1.4l0.7,0.5C50.3,124.6,48.7,125.2,47.3,125.2z M43.6,120H51c0-2.3-1.5-3.6-3.7-3.6
		C45.4,116.4,43.8,117.7,43.6,120z M47.5,114.1l1.7-2.3v0H48l-1.4,2.3v0.1C46.6,114.1,47.5,114.1,47.5,114.1z"
        />
        <path
          d="M62.3,111.8v13.3h-0.9V123c-0.8,1.4-2.2,2.2-3.8,2.2c-2.5,0-4.5-1.7-4.5-4.8s2-4.8,4.6-4.8c1.6,0,3,0.7,3.8,2.2v-6
		L62.3,111.8L62.3,111.8z M54,120.4c0,2.6,1.7,3.9,3.7,3.9s3.7-1.6,3.7-3.9s-1.6-3.9-3.7-3.9S54,117.7,54,120.4z"
        />
        <path d="M65.6,112.6c0,1-1.5,1-1.5,0S65.6,111.6,65.6,112.6z M64.4,115.6v9.4h0.9v-9.4H64.4z" />
        <path
          d="M69.5,112.8v2.8h3.1v0.8h-3.1v5.7c0,1.3,0.3,2.2,1.7,2.2c0.4,0,0.9-0.1,1.4-0.4l0.3,0.8c-0.6,0.3-1.1,0.5-1.7,0.5
		c-1.9,0-2.6-1.2-2.6-3v-5.7h-1.9v-0.8h1.9v-2.7L69.5,112.8L69.5,112.8z"
        />
        <path
          d="M89.1,125l-1.4-3.3H80l-1.4,3.3h-1.1l5.8-13.3h1.1l5.8,13.3H89.1L89.1,125z M87.3,120.8l-3.5-8.1l-3.5,8.1H87.3L87.3,120.8
		z"
        />
        <path
          d="M98.7,115.3l0.6,0.5l-0.9,1.1c0.7,0.7,1.1,1.7,1.1,3.2c0,1.6-0.9,3.3-2.4,4c1.6,0.6,2.5,1.8,2.5,3.4c0,2.5-1.9,3.7-4.3,3.7
		s-4.3-1.4-4.3-3.7h0.9c0,1.9,1.6,2.8,3.4,2.8s3.4-0.8,3.4-2.8s-1.8-2.8-3.4-2.8c-2.6,0-4.3-2-4.3-4.5c0-2.9,1.9-4.6,4.3-4.6
		c0.9,0,1.9,0.3,2.6,0.8L98.7,115.3L98.7,115.3z M91.8,120.1c0,1.9,1.3,3.6,3.4,3.6c1.9,0,3.4-1.7,3.4-3.6c0-2.4-1.5-3.7-3.4-3.7
		S91.8,117.6,91.8,120.1z"
        />
        <path
          d="M101.7,115.7l0,1.7c0.6-1.3,1.9-1.8,3-1.8c0.7,0,1.3,0.2,1.9,0.6l-0.4,0.8c-0.5-0.3-1-0.4-1.6-0.4c-1.7,0-3,1.4-3,3.1v5.5
		h-0.9v-9.4L101.7,115.7L101.7,115.7z"
        />
        <path d="M108.7,112.6c0,1-1.5,1-1.5,0S108.7,111.6,108.7,112.6z M107.5,115.6v9.4h0.9v-9.4H107.5z" />
        <path
          d="M118,123.7c-0.9,0.9-2.1,1.4-3.3,1.4c-2.6,0-4.7-1.8-4.7-4.8s2.1-4.8,4.7-4.8c1.2,0,2.4,0.5,3.3,1.4l-0.6,0.6
		c-0.7-0.8-1.8-1.1-2.7-1.1c-2.1,0-3.8,1.4-3.8,3.9s1.7,3.9,3.8,3.9c1,0,2-0.4,2.7-1.2L118,123.7L118,123.7z"
        />
        <path
          d="M119,120.4c0-3,2.1-4.9,4.6-4.9s4.6,1.9,4.6,4.9s-2.1,4.8-4.6,4.8S119,123.4,119,120.4z M127.4,120.4c0-2.4-1.7-4-3.7-4
		s-3.7,1.6-3.7,4s1.7,3.9,3.7,3.9S127.4,122.8,127.4,120.4z"
        />
        <path d="M130.8,111.8v13.3h-0.9v-13.3C129.9,111.8,130.8,111.8,130.8,111.8z" />
        <path
          d="M132.3,120.4c0-2.8,2.1-4.8,4.6-4.8s4.9,1.6,4.5,5.3h-8.2c0.2,2.2,1.8,3.5,3.7,3.5c1.2,0,2.6-0.5,3.3-1.4l0.6,0.5
		c-0.9,1.2-2.5,1.8-3.9,1.8C134.3,125.2,132.3,123.3,132.3,120.4L132.3,120.4z M140.6,120c0-2.3-1.5-3.6-3.7-3.6
		c-1.9,0-3.5,1.3-3.7,3.6H140.6L140.6,120z"
        />
        <path
          d="M148.6,115.7v1.7c0.7-1.3,2-1.8,3.2-1.8c2.4,0,4.1,1.5,4.1,4.1v5.4h-0.9v-5.4c0-2.1-1.3-3.3-3.2-3.2
		c-1.9,0-3.2,1.5-3.2,3.4v5.2h-0.9v-9.4L148.6,115.7L148.6,115.7z"
        />
        <path
          d="M157.3,120.4c0-2.8,2.1-4.8,4.6-4.8s4.9,1.6,4.5,5.3h-8.2c0.2,2.2,1.8,3.5,3.7,3.5c1.2,0,2.6-0.5,3.3-1.4l0.6,0.5
		c-0.9,1.2-2.5,1.8-3.9,1.8C159.4,125.2,157.3,123.3,157.3,120.4L157.3,120.4z M165.6,120c0-2.3-1.5-3.6-3.7-3.6
		c-1.9,0-3.5,1.3-3.7,3.6H165.6L165.6,120z"
        />
        <path d="M171.3,119.5l2.7-3.8h1.1v0l-3.3,4.5l3.5,4.8v0h-1.1l-3-4.2l-3,4.2h-1.1v0l3.5-4.8l-3.3-4.5v0h1.1L171.3,119.5z" />
        <path
          d="M178.6,112.8v2.8h3.1v0.8h-3.1v5.7c0,1.3,0.3,2.2,1.7,2.2c0.4,0,0.9-0.1,1.4-0.4l0.3,0.8c-0.6,0.3-1.1,0.5-1.7,0.5
		c-1.9,0-2.6-1.2-2.6-3v-5.7h-1.9v-0.8h1.9v-2.7L178.6,112.8L178.6,112.8z"
        />
        <path
          d="M188.7,111.8v6c0.7-1.5,2.2-2.2,3.8-2.2c2.5,0,4.6,1.8,4.6,4.8s-2,4.8-4.6,4.8c-1.6,0-3-0.8-3.8-2.2v2.1h-0.9v-13.3
		L188.7,111.8L188.7,111.8z M188.7,120.3c0,2.3,1.6,3.9,3.7,3.9s3.7-1.3,3.7-3.9s-1.7-3.9-3.7-3.9S188.7,118,188.7,120.3z"
        />
        <path
          d="M207.5,115.7v9.4h-0.9v-2c-0.9,1.5-2.2,2.1-3.7,2.1c-2.5,0-4.6-2-4.6-4.8s2.1-4.8,4.6-4.8c1.5,0,3,0.7,3.7,2.2v-2.1
		L207.5,115.7L207.5,115.7z M199.2,120.4c0,2.4,1.7,3.9,3.7,3.9c5.1,0,5.1-7.8,0-7.8C200.8,116.4,199.2,118,199.2,120.4L199.2,120.4
		z"
        />
        <path
          d="M210.3,115.7v1.7c0.7-1.3,2-1.8,3.2-1.8c2.4,0,4.1,1.5,4.1,4.1v5.4h-0.9v-5.4c0-2.1-1.3-3.3-3.2-3.2
		c-1.9,0-3.2,1.5-3.2,3.4v5.2h-0.9v-9.4L210.3,115.7L210.3,115.7z"
        />
        <path d="M220.4,111.8v8l4.3-4.1h1.2v0l-4.6,4.4l5.1,4.9v0.1h-1.1l-4.9-4.6v4.6h-0.9v-13.3L220.4,111.8L220.4,111.8z" />
      </g>
    </svg>
  )
}

CaNextBankLogo.displayName = "CaNextBankLogo"

export default CaNextBankLogo
